import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4abd070e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper" }

export function render(_ctx, _cache) {
  const _component_v_last_viewed_clients_tabs = _resolveComponent("v-last-viewed-clients-tabs")
  const _component_v_scrollable_menu = _resolveComponent("v-scrollable-menu")
  const _component_active = _resolveComponent("active")
  const _component_all = _resolveComponent("all")
  const _component_inClub = _resolveComponent("inClub")
  const _component_new = _resolveComponent("new")
  const _component_inDebt = _resolveComponent("inDebt")
  const _component_endSoon = _resolveComponent("endSoon")
  const _component_former = _resolveComponent("former")
  const _component_corporate = _resolveComponent("corporate")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_last_viewed_clients_tabs),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_scrollable_menu, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => ((_ctx.activeTab) = $event)),
          _ctx.clickOnTab
        ],
        items: _ctx.tabs
      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.hasLastViewedClients ? 'mt-2 members_wrapper_with_last_viewed_clients' : 'mt-2 members_wrapper' )
      }, [
        (_ctx.isShowActiveChild)
          ? (_openBlock(), _createBlock(_component_active, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isShowAllChild)
          ? (_openBlock(), _createBlock(_component_all, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.isShowInClubChild)
          ? (_openBlock(), _createBlock(_component_inClub, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.isShowNewChild)
          ? (_openBlock(), _createBlock(_component_new, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.isShowInDebtChild)
          ? (_openBlock(), _createBlock(_component_inDebt, { key: 4 }))
          : _createCommentVNode("", true),
        (_ctx.isShowEndSoonChild)
          ? (_openBlock(), _createBlock(_component_endSoon, { key: 5 }))
          : _createCommentVNode("", true),
        (_ctx.isShowFormerChild)
          ? (_openBlock(), _createBlock(_component_former, { key: 6 }))
          : _createCommentVNode("", true),
        (_ctx.isShowCorporateChild)
          ? (_openBlock(), _createBlock(_component_corporate, { key: 7 }))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 64))
}